export default class extends Controller {
  static targets = ["display", "value", "amMeridian", "pmMeridian"];

  amSelect(event, setValue=true) {
    event && event.preventDefault();
    this.meridian = false;
    setValue && this.setValue();
  }

  pmSelect(event, setValue=true) {
    event && event.preventDefault();
    this.meridian = true;
    setValue && this.setValue();
  }

  formatValues() {
    this.setDisplay();
    this.setValue();
  }

  formatDisplay() {
    if (this.lastDisplayChar === "P" || this.lastDisplayChar === "p") this.pmSelect(null, false);
    if (this.lastDisplayChar === "A" || this.lastDisplayChar === "a") this.amSelect(null, false);
    this.display = this.display;
    this.setValue();
  }

  //
  // INTERNAL USE
  //

  setDisplay() {
    this.display = `${this.enteredHours}:${this.enteredMinutes}`;
  }

  setValue() {
    const hours = `0${this.meridianizedDisplayHours}`.slice(-2);
    this.value = `${hours}:${this.enteredMinutes}`;
  }

  //
  // GETTERS AND SETTERS
  //

  get meridian() {
    return this.pmMeridianTarget.classList.contains("chosen");
  }

  set meridian(val) {
    this.amMeridianTarget.classList[val ? "remove" : "add"]("chosen");
    this.pmMeridianTarget.classList[val ? "add" : "remove"]("chosen");
  }

  get enteredHours() {
    const hour = parseInt(this.minutesAndHoursStrings[0]);
    if ((!hour && hour !== 0) || hour < 0 || hour >= 24) {
      this.meridian = hour === 0 ? false : this.meridian;
      return 12;
    }
    if (hour > 12) {
      this.meridian = true;
      return hour - 12;
    }
    return hour;
  }

  get enteredMinutes() {
    let minutes = parseInt(this.minutesAndHoursStrings[1]);
    if (!minutes || minutes < 0) minutes = 0;
    if (minutes > 59) minutes = 59;
    return `00${minutes}`.slice(-2);
  }

  // aka "The Ugly One" - but it works and it's past quitting time on the last day of my work week
  get minutesAndHoursStrings() {
    const enteredString = this.display.replace(":", "");
    if (enteredString.length === 1) return [enteredString, 0];
    if (enteredString.length === 2) {
      const num = parseInt(enteredString);
      if (num >= 1 && num <= 12) return [num, 0];
      if (num >= 1 && num <= 23) {
        this.meridian = true;
        return [num - 12, 0];
      }
      if (num === 0 || num === 24) {
        this.meridian = false;
        return [12, 0];
      }
    }
    return [enteredString.slice(0, -2), enteredString.slice(-2)];
  }

  get display() {
    return this.displayTarget.value;
  }

  set display(val) {
    this.displayTarget.value = val.replace(/[^0-9]/g, "");
    this.displayTarget.value = this.display.slice(0, this.cap);
    if (this.display.length > 2) {
      const [hours, mins] = this.minutesAndHoursStrings;
      this.displayTarget.value = `${hours}:${mins}`;
    }
  }

  get meridianizedDisplayHours() {
    let hours = parseInt(this.enteredHours);
    hours = hours === 12 && !this.meridian ? 0 : hours;
    const res = hours + (this.meridian ? 12 : 0);
    return res === 24 ? 12 : res;
  }

  get value() {
    return this.valueTarget.value;
  }

  get valueHours() {
    return parseInt(this.value.split(":")[0] || 0);
  }

  set value(val) {
    this.valueTarget.value = val;
  }

  get cap() {
    const display = this.display;
    const firstDigit = parseInt(display[0]) || 0;
    if (firstDigit > 2) return 3;
    if (firstDigit < 2) return 4;
    return (parseInt(display[1]) || 0) > 4 ? 3 : 4;
  }

  get lastDisplayChar() {
    return this.display[this.display.length - 1];
  }
};



// WEBPACK FOOTER //
// ./app/components/forms/fields/assets/javascript/forms-fields-time-input-controller.js